import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Cookies } from "react-cookie";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";

export const exportUnregisteredFlatList = createAsyncThunk(
  "exportUnregisteredFlatList",
  async (id) => {
    try {
      const cookies = new Cookies();
      const token = cookies.get("token");

      const response = await AxiosInstance.get(
        `${API_KEY}/api/dashboard/export-unregistered-flats/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response;
    } catch (error) {
      if (error.response) {
        throw error.response.data.message;
      } else {
        throw error;
      }
    }
  }
);
const initialState = {
  isLoading: false,
  exportUnregisteredFlatListData: null,
  isError: false,
  errorMessage: "",
};

const exportUnregisteredFlatListSlice = createSlice({
  name: "exportUnregisteredFlatList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(exportUnregisteredFlatList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(exportUnregisteredFlatList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.exportUnregisteredFlatListData = action.payload;
    });
    builder.addCase(exportUnregisteredFlatList.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default exportUnregisteredFlatListSlice.reducer;
